module.exports = __webpack_public_path__ + "static/media/exterminador_p.55162e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/exterminador_p.png
// module id = 1156
// module chunks = 0